/**
 * constants.js
 * Description: exports objects of regex based on its classification
 */

/* eslint-disable no-useless-escape */
export const keywords = {
  CODE_START: /^(HAI)$/,
  CODE_END: /^(KTHXBYE)$/,
  COMMENT_LINE: /^(BTW)$/,
  COMMENT_START: /^(OBTW)$/,
  COMMENT_END: /^(TLDR)$/,
  VAR_DEC: /^(I HAS A)$/,
  VAR_INIT: /^(ITZ)$/,
  VAR_ASSIGN: /^R$/,
  VAR_IT: /^IDENT$/,
  OP_ADD: /^(SUM OF)$/,
  OP_SUB: /^(DIFF OF)$/,
  OP_MUL: /^(PRODUKT OF)$/,
  OP_DIV: /^(QUOSHUNT OF)$/,
  OP_MOD: /^(MOD OF)$/,
  OP_MAX: /^(BIGGR OF)$/,
  OP_MIN: /^(SMALLR OF)$/,
  OP_AND: /^(BOTH OF)$/,
  OP_OR: /^(EITHER OF)$/,
  OP_XOR: /^(WON OF)$/,
  OP_NOT: /^(NOT)$/,
  OP_ANY: /^(ANY OF)$/,
  OP_ALL: /^(ALL OF)$/,
  OP_EQU: /^(BOTH SAEM)$/,
  OP_NEQ: /^(DIFFRINT)$/,
  INFOP_END: /^(MKAY)$/,
  MULOP_SEP: /^(AN)$/,
  //OP_CONCAT : /^(SMOOSH)$/,
  //OP_TYPCAS : /^(MAEK)$/,
  //A : /^(A)$/,
  //NEW_TYPE : /^(IS NOW A)$/,
  OUTPUT: /^(VISIBLE)$/,
  INPUT: /^(GIMMEH)$/,
  IF_START: /^(O RLY\?)$/,
  IF_TRUE: /^(YA RLY)$/,
  //IF_ELIF  : /^(MEBBE)$/,
  IF_FALSE: /^(NO WAI)$/,
  IF_END: /^(OIC)$/,
  SWITCH_START: /^(WTF\?)$/,
  SWITCH_CASE: /^(OMG)$/,
  SWITCH_DEF: /^(OMGWTF)$/,
  SWITCH_BREAK: /^(GTFO)$/,
  //LOOP_START : /^(IM IN YR)$/,
  //LOOP_INC   : /^(UPPIN)$/,
  //LOOP_DEC   : /^(NERFIN)$/,
  //LOOP_COND  : /^(TIL)$/,
  //LOOP_WHILE : /^(WILE)$/,
  //LOOP_END   : /^(IM OUTTA YR)$/,
};

export const STR_LITERAL = /\s?"(.*)"/;
export const STR_DELIM = /"/;
export const literals = {
  INT: /^\-?\d+$/,
  FLOAT: /\b(\-?\d+\.\d+)\b/,
  STRING: /^".*"$/,
  BOOL: /(WIN)|(FAIL)/,
  TYPE: /\b(NOOB | TROOF | NUMBR | NUMBAR | YARN | TYPE)\b/,
};
export const NUMBR = literals.INT;
export const NUMBAR = literals.FLOAT;
export const TROOF = literals.BOOL;

export const identifier = /^([a-zA-Z][a-zA-Z0-9_]*)$/;
